<template>
  <div>
    <div
      v-for="(nav, i) in footerNavOption"
      :key="i"
      @click="scrollTo"
    >
      <router-link
        class="f-s-14 grey-1 l-h-30 l-s-0_6-p text-decoration-none blue-hover"
        :to="{name: nav.routeName}"
      >
        {{ nav.label }}
      </router-link>
    </div>
  </div>
</template>

<script>
import { scrollToTop } from '@/helpers/helpers';
import {
  R_ABOUT_US,
  R_SERVICES,
  R_EXPERTISE,
  R_CAREERS,
  R_CONTACT_US,
  R_BLOG,
} from '@/router/routes';

export default {
  name: 'Company',
  data() {
    return {
      footerNavOption: [
        {
          label: 'About Us',
          routeName: R_ABOUT_US,
        },
        {
          label: 'Services',
          routeName: R_SERVICES,
        },
        {
          label: 'Expertise',
          routeName: R_EXPERTISE,
        },
        {
          label: 'Careers',
          routeName: R_CAREERS,
        },
        {
          label: 'Blog',
          routeName: R_BLOG,
        },
        {
          label: 'Contact Us',
          routeName: R_CONTACT_US,
        },
      ],
    };
  },
  methods: {
    scrollTo() {
      scrollToTop();
    },
  },
};
</script>
